// 统一歌词内容处理（强制统一策略）

export function looksLikeHtmlDocument(text, contentType = '') {
  try {
    const ct = String(contentType || '').toLowerCase();
    const s = String(text || '').trim();
    const sl = s.toLowerCase();
    if (ct.includes('text/html')) return true;
    if (sl.startsWith('<!doctype html')) return true;
    // React SPA 的典型 root（你截图里就有）
    if (s.includes('<div id="root"></div>')) return true;
    return false;
  } catch (_) {
    return false;
  }
}

export function stripTimeTagsToPlainText(text) {
  const s = String(text ?? '');
  // LRC: [mm:ss.xx] / [mm:ss]
  const noLrc = s.replace(/\[\d{1,2}:\d{2}(?:\.\d{2})?\]/g, '');
  // SRT: 00:00:00,000 --> 00:00:02,000
  const noSrt = noLrc.replace(/\d{1,2}:\d{2}:\d{2},\d{3}\s*-->\s*\d{1,2}:\d{2}:\d{2},\d{3}/g, '');
  return noSrt;
}

